<p-autoComplete #content #autoComplete
  class="autocompleteWidth100"
  [suggestions]="suggestions()"
  [group]="group()"
  [dropdown]="showDropdownIcon()"
  dropdownMode="current"
  [forceSelection]="false"
  [completeOnFocus]="false"
  (completeMethod)="onSearch($event)"
  (onSelect)="onSelect($event)"
  (onBlur)="blurHandler($event)"
  [hisDdKey]="hisDdKey()"
  [disabled]="disabled()"
  [inputId]="inputId()">

  <!-- hint about limited selection list -->
  @if (isSuggestionsLimited()) {
    <ng-template #header>
      <span>{{'view.controls.multiselect.dropdown.filteredOptionsHeader' | hisUi: limit(): unselectedSuggestions().length}}</span>
    </ng-template>
  }

  <!-- group template -->
  @if (group()) {
    <ng-template let-group #group>
      <div class="p-autocomplete-item-group">
        @if (group.icon) {
          <img [hisImage]="group.icon" class="inlineicon">
        }
        <span class="p-autocomplete-item-group-label">{{ group.label }}</span>
      </div>
    </ng-template>
  }

  <!-- option template -->
  <ng-template let-item #item>
    {{item.label}}
  </ng-template>

  @if (isSuggestionsLimited()) {
    <ng-template #footer>
      <button hisMultiselectSelectionShowAll
        [title]="'common.showAll' | hisUi"
        hisImage="ARROW_RIGHT_FAT"
        class="icon"
        (click)="requestOptionDialog()">
        <span>{{'common.showAll' | hisUi}}</span>
      </button>
    </ng-template>
  }

  <!-- template for empty suggestions message -->
  <ng-template #empty>
    @if (loading()) {
      <!-- suggestions are still loading from the server -->
      <p-progressSpinner
        class="multiselect-loading-spinner"
        strokeWidth="8"
        [style]="{width: '1.5rem', height: '1.5rem', 'margin-right': '0.5rem'}"
        animationDuration="5s">
      </p-progressSpinner>
      <span class="multiselect-loading-label" style="vertical-align: middle;">{{'common.loading' | hisUi}}</span>
    } @else if (filteredSuggestionsCount() > 0) {
      <!-- every suggestion matching the query is already selected -->
      <span>{{'common.allEntriesSelected' | hisUi}}</span>
    } @else {
      <!-- no suggestions match the query -->
      <span>{{'common.noResultsFound' | hisUi}}</span>
    }
  </ng-template>
</p-autoComplete>
